/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { WebsiteTemplateCapabilities } from './WebsiteTemplateCapabilities';
import type { WebsiteTemplateKey } from './WebsiteTemplateKey';
import type { WebsiteTemplatePreviewDescriptor } from './WebsiteTemplatePreviewDescriptor';
import type { WebsiteTemplateRegistryVisibility } from './WebsiteTemplateRegistryVisibility';
import type { WebsiteTemplateVersion } from './WebsiteTemplateVersion';
export type WebsiteTemplateRegistryTemplateSummary = {
    kind: WebsiteTemplateRegistryTemplateSummary.kind;
    key: WebsiteTemplateKey;
    version: WebsiteTemplateVersion;
    name: string;
    description?: string;
    tags?: Array<string>;
    author?: string;
    origin?: string;
    createdAt?: string;
    updatedAt?: string;
    preview?: WebsiteTemplatePreviewDescriptor;
    /**
     * Capabilities derived from the validated template definition.
     */
    capabilities: WebsiteTemplateCapabilities;
    registryTemplateId: string;
    ownerTenantId?: string;
    visibility: WebsiteTemplateRegistryVisibility;
    mockPreviewUrl?: string;
};
export namespace WebsiteTemplateRegistryTemplateSummary {
    export enum kind {
        WEBSITE = 'website',
    }
}

